import { useEffect, useCallback, useRef, useState } from 'react'
import { Link } from 'wouter'
import { Button } from '@/components/ui/button'
import { useLoading } from './LoadingProvider'
import { Ghost, Home, Sparkles } from 'lucide-react'

const funMessages = [
	"Looks like this page is playing hide and seek... and winning!",
	"This page went on vacation and forgot to leave a forwarding address.",
	"Houston, we have a problem. This page has left the building.",
	"Plot twist: The page you wanted was the friends we made along the way.",
	"This page is more elusive than a secret hideaway!",
]

export default function NotFound() {
	const { showLoader } = useLoading()
	const isMounted = useRef(true)
	const [message] = useState(() => funMessages[Math.floor(Math.random() * funMessages.length)])

	const handleNavigate = useCallback(() => {
		if(isMounted.current) {
			showLoader(800)
		}
	}, [showLoader])

	useEffect(() => {
		return () => {
			isMounted.current = false
		}
	}, [])

	return (
		<div className="min-h-auto flex items-center justify-center bg-[#18181B] px-4 h-full">
			<div className="text-center max-w-md h-full flex flex-col justify-center">
				<div className="mb-6 relative">
					<Ghost className="w-24 h-24 mx-auto text-[#EF4444] animate-bounce" />
					<Sparkles className="w-6 h-6 text-[#EF4444] absolute top-0 right-1/4 animate-pulse" />
					<Sparkles className="w-4 h-4 text-[#BABABB] absolute bottom-4 left-1/4 animate-pulse delay-150" />
				</div>
				<div className="mb-4">
					<span className="text-8xl font-bold text-[#EF4444]">
						404
					</span>
				</div>
				<h1 className="text-2xl font-semibold mb-3 text-[#ffffff]">
					Whoops! Page Not Found
				</h1>
				<p className="text-[#BABABB] mb-8 leading-relaxed">
					{message}
				</p>
				<Button
					asChild
					size="lg"
					onClick={handleNavigate}
					className="px-8 bg-[#EF4444] hover:bg-[#DC2626] text-white h-10"
				>
					<Link href="/" className="flex items-center gap-2">
						<Home className="w-4 h-4" />
						Take Me Home
					</Link>
				</Button>
			</div>
		</div>
	)
}